/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as React from 'react';

export interface IPromoBannerCloseButton {
    closeButtonAriaLabel?: string;
    label?: string;
    onClose(): void;
}

export const PromoBannerCloseButton: React.FC<IPromoBannerCloseButton> = ({ closeButtonAriaLabel, label, onClose }) => (
    <button className='ms-promo-banner__close-button' aria-label={closeButtonAriaLabel} onClick={onClose}>
        <span className='ms-promo-banner__close-button__label' aria-hidden={true}>{label}</span>
    </button>
);